<ng-container *ngIf="heroConfig$ | async as config">
  <fin-destination-hero
    [title]="config.title"
    [backgroundImage]="config.backgroundImage"
    [destinationCode]="config.destinationCode"
    [enableAward]="config.enableAward"
    [enableAurinkomatkat]="config.enableAurinkomatkat"
    [enablePromoCode]="config.enablePromoCode"
    [contentType]="config.contentType"
    [isInCampaign]="config.isInCampaign"
    [campaignLabel]="
      config?.discountCode
        ? (campaignLabelKey$
          | async
          | finLocalization
            : {
                amount:
                  config?.discountCode?.type === 'fixed'
                    ? (discountCodeFixedAmount$ | async)
                    : config?.discountCode?.amount,
              })
        : (campaignLabelKey$ | async | finLocalization)
    "
    [campaignEndText]="config.campaignEndText"
    [enableBlackTeaser]="config.campaignBlackTeaser"
  />
</ng-container>
